export default {
  methods: {
    showErrors(error, alternativeMessage = '') {
      let responseData = error.response?.data;
      // En caso de la respuesta ser arrayBuffer (casos de descargas se controla el error)
      if (responseData instanceof ArrayBuffer) {
        try {
          const decoder = new TextDecoder('utf-8');
          const text = decoder.decode(responseData);
          const json = JSON.parse(text);
          responseData = json;
          if (
            !Array.isArray(responseData.error) &&
            typeof responseData.error === 'object' &&
            responseData.error !== null
          ) {
            this.$notify.error(responseData.error.mensaje);
          }

          if (Array.isArray(responseData.error) && responseData.error.length > 0) {
            responseData.error.forEach(element => {
              this.$notify.error(element.mensaje);
            });
            return;
          }
        } catch (e) {
          this.$notify.error(e);
        }
        return;
      }

      if (String(responseData.status).charAt(0) === '4' && 'error' in responseData) {
        let formattedError = JSON.parse(JSON.stringify(responseData.error));
        if (
          !Array.isArray(formattedError) &&
          typeof formattedError === 'object' &&
          formattedError !== null
        ) {
          formattedError = [formattedError];
        }
        if (Array.isArray(formattedError) && formattedError.length > 0) {
          formattedError.forEach(element => {
            const message =
              'campo' in element ? `${element.campo}: ${element.mensaje}` : element.mensaje;
            this.$notify.error(message);
          });
          return;
        }
      }

      if (alternativeMessage !== '') this.$notify.error(alternativeMessage);
      if (alternativeMessage === '')
        this.$notify.error('Ha ocurrido un error al procesar esta petición');
    }
  }
};
